import React from 'react';
import Swal from 'sweetalert2';
import authAxios from "../../services/Token";
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faSave, faTimes, faSearch, faSpinner } from '@fortawesome/free-solid-svg-icons';

class CrearFormulario extends React.Component {
    _isMounted = false;

    constructor(props) {
        super(props);
        this.state = {
            filteredItems: [],
            isLoadingOpenSub: false,
            CampoInput: '',
            CampoInputName: '',
            searchTerm: '',
            guardando: false,
            datosFormulario: {},
            modalSelectInstance: null // Para guardar la instancia de Bootstrap
        };
    }

    componentDidMount() {
        this._isMounted = true;
        console.log('CrearFormulario montado');
        console.log('Props recibidas:', {
            menu: this.props.menu,
            tabla_length: this.props.tabla?.length,
            pesta_length: this.props.pesta?.length,
            llave: this.props.llave,
            relacionid: this.props.relacionid,
            idRegistro: this.props.idRegistro
        });

        this.inicializarModalBootstrap();
        if (this.props.idRegistro) {
            this.cargarDatosRegistro(this.props.idRegistro);
        } else {
            this.inicializarFormulario();
        }
    }

    componentDidUpdate(prevProps) {
        if (prevProps.idRegistro !== this.props.idRegistro) {
            if (this.props.idRegistro) {
                this.cargarDatosRegistro(this.props.idRegistro);
            } else {
                this.inicializarFormulario();
            }
        }
    }

    cargarDatosRegistro = async (idRegistro) => {
        try {
            this.setState({ guardando: true });
            const response = await authAxios.get(`master/ver/${this.props.menu}/${idRegistro}`);
            if (this._isMounted && response.data) {
                // response.data.result contains the fields
                this.setState({
                    datosFormulario: response.data.result || {},
                    guardando: false
                });
            }
        } catch (error) {
            console.error("Error cargando datos del registro:", error);
            if (this._isMounted) {
                this.setState({ guardando: false });
                Swal.fire("Error", "No se pudieron cargar los datos del registro", "error");
            }
        }
    }

    componentWillUnmount() {
        this._isMounted = false;
        // Limpiar instancia del modal
        if (this.state.modalSelectInstance) {
            this.state.modalSelectInstance.dispose();
        }
    }

    /**
     * Inicializar instancia de Bootstrap para el modal
     */
    inicializarModalBootstrap = () => {
        setTimeout(() => {
            const modalId = `ModalSelectSub_${this.props.menu}`;
            const modalElement = document.getElementById(modalId);
            if (modalElement && window.bootstrap) {
                try {
                    const modalInstance = new window.bootstrap.Modal(modalElement, {
                        backdrop: true,
                        keyboard: true
                    });
                    this.setState({ modalSelectInstance: modalInstance });
                    console.log(`Modal Bootstrap ${modalId} inicializado`);
                } catch (error) {
                    console.error('Error inicializando modal Bootstrap:', error);
                }
            }
        }, 100);
    }

    /**
     * Inicializar datos del formulario
     */
    inicializarFormulario = () => {
        const datosFormulario = {};

        if (this.props.tabla && Array.isArray(this.props.tabla)) {
            this.props.tabla.forEach(campo => {
                if (campo.nombre_campo !== 'id') {
                    datosFormulario[campo.nombre_campo] = '';
                }
            });
        }

        // Si es un archivo vinculado a paciente, establecer el paciente_id
        if (this.props.llave && this.props.relacionid) {
            datosFormulario[this.props.llave] = this.props.relacionid;
            console.log('Campo oculto establecido:', this.props.llave, '=', this.props.relacionid);
        }

        console.log('Formulario inicializado:', datosFormulario);
        this.setState({ datosFormulario });
    }

    /**
     * Guardar el registro
     */
    saverel = async () => {
        try {
            // Validar campos obligatorios
            const errores = this.validarFormulario();
            if (errores.length > 0) {
                Swal.fire({
                    title: 'Campos Requeridos',
                    html: '<ul style="text-align: left;">' + errores.map(e => `<li>${e}</li>`).join('') + '</ul>',
                    icon: 'warning',
                    confirmButtonText: 'Entendido'
                });
                return;
            }

            this.setState({ guardando: true });
            Swal.showLoading();

            const u = localStorage.getItem('idusuario');
            const formId = `form_registro_rel_${this.props.menu}`;
            const form = document.getElementById(formId);

            if (!form) {
                throw new Error(`Formulario ${formId} no encontrado en el DOM`);
            }

            const formData = new FormData(form);

            console.log('Enviando datos al servidor...');
            console.log('Menu:', this.props.menu);
            console.log('Usuario:', u);

            const response = await authAxios.post(
                `master/registrar/${this.props.menu}/${u}`,
                formData,
                {
                    headers: {
                        'Content-Type': 'multipart/form-data'
                    }
                }
            );

            console.log('Respuesta del servidor:', response.data);

            if (this._isMounted) {
                if (response.data.Status) {
                    Swal.fire({
                        title: '¡Éxito!',
                        text: response.data.msj || 'Registro guardado correctamente',
                        icon: 'success',
                        confirmButtonText: 'Continuar'
                    });

                    // Reset del formulario
                    form.reset();
                    this.inicializarFormulario();

                    // Guardar en localStorage para redirección si es el menú de archivo
                    if (this.props.menu === 200) {
                        localStorage.setItem('Archivo', 200);
                        localStorage.setItem('TablaId', response.data.ultimo_id);
                        console.log('Datos guardados en localStorage para redirección:', {
                            Archivo: 200,
                            TablaId: response.data.ultimo_id
                        });
                    }

                    // Llamar callback con el ID correcto y los datos guardados
                    if (this.props.actualizarRelaciones) {
                        const idRegistro = response.data.id || response.data.ultimo_id || Date.now();
                        console.log('Llamando callback con ID:', idRegistro);
                        this.props.actualizarRelaciones(
                            this.props.tabla[0].nombre_tabla,
                            idRegistro,
                            response.data.da // Pasar también los datos guardados
                        );
                    }
                } else {
                    Swal.fire({
                        title: 'Error',
                        text: response.data.msj || 'Error al guardar el registro',
                        icon: 'error',
                        confirmButtonText: 'Entendido'
                    });
                }

                this.setState({ guardando: false });
            }
        } catch (error) {
            console.error('Error al guardar:', error);
            this.setState({ guardando: false });

            const mensajeError = error.response?.data?.msj || error.message || 'Error desconocido al guardar el registro';
            Swal.fire({
                title: 'Error',
                text: mensajeError,
                icon: 'error',
                confirmButtonText: 'Entendido'
            });
        }
    }

    /**
     * Validar campos obligatorios
     */
    validarFormulario = () => {
        const errores = [];
        const formId = `form_registro_rel_${this.props.menu}`;
        const form = document.getElementById(formId);

        if (!form) {
            errores.push(`Formulario ${formId} no encontrado`);
            return errores;
        }

        this.props.tabla.forEach(campo => {
            if (campo.obligatorio === 1 && campo.nombre_campo !== 'id') {
                const input = form.elements[campo.nombre_campo];

                if (!input || !input.value || input.value.trim() === '') {
                    errores.push(`${campo.nombre_titulo} es requerido`);
                }
            }
        });

        console.log('Validación completada. Errores:', errores);
        return errores;
    }

    /**
     * Buscar registros en tabla relacionada
     */
    BuscarSub = (tabla, id, nombre, campo, opcional) => {
        const menuSuffix = `_${this.props.menu}`;
        
        let actualOpcional = opcional;
        if (tabla === 'cie_10' && !actualOpcional) {
            actualOpcional = 'codigo';
        }

        this.setState({
            filteredItems: [],
            isLoadingOpenSub: true,
            CampoInput: `${campo}${menuSuffix}`,
            CampoInputName: `${campo}_name${menuSuffix}`,
            searchTerm: ''
        });

        // Abrir el modal inmediatamente
        this.abrirModalSeleccion();

        const payload = { tabla, id, nombre, opcional: actualOpcional };

        authAxios
            .post("master/relacion", payload)
            .then((response) => {
                console.log('Datos relacionados recibidos:', response.data);
                if (this._isMounted) {
                    this.setState({
                        filteredItems: response.data || [],
                        isLoadingOpenSub: false
                    });
                }
            })
            .catch(error => {
                console.error('Error en BuscarSub:', error);
                if (this._isMounted) {
                    this.setState({ isLoadingOpenSub: false });
                    Swal.fire('Error', 'Error al cargar los datos', 'error');
                    this.cerrarModalSeleccion();
                }
            });
    }

    /**
     * Abrir modal de selección usando Bootstrap
     */
    abrirModalSeleccion = () => {
        const modalId = `ModalSelectSub_${this.props.menu}`;
        const modalElement = document.getElementById(modalId);
        if (!modalElement) {
            console.error(`${modalId} no encontrado en el DOM`);
            return;
        }

        try {
            // Usar Bootstrap Modal
            if (window.bootstrap?.Modal) {
                // Intentar obtener instancia existente o crear una nueva
                let modal = window.bootstrap.Modal.getInstance(modalElement);
                if (!modal) {
                    modal = new window.bootstrap.Modal(modalElement);
                }
                modal.show();
                console.log(`Modal de búsqueda ${modalId} abierto con Bootstrap`);
            } else {
                // Fallback para abrir manualmente
                modalElement.classList.add('show');
                modalElement.style.display = 'block';
                document.body.classList.add('modal-open');

                // Crear backdrop
                const backdrop = document.createElement('div');
                backdrop.className = 'modal-backdrop fade show';
                backdrop.style.zIndex = 1080; // Encima del modal principal (1050/1060)
                document.body.appendChild(backdrop);
                console.log('Modal de búsqueda abierto manualmente');
            }
        } catch (error) {
            console.error('Error abriendo modal:', error);
        }
    }

    /**
     * Seleccionar registro
     */
    Seleccionar = (id, nombre) => {
        const { CampoInput, CampoInputName } = this.state;

        console.log('Seleccionando:', id, nombre);

        const suffix = `_${this.props.menu}`;
        const idFieldKey = CampoInput.endsWith(suffix) ? CampoInput.slice(0, -suffix.length) : CampoInput;
        const nameFieldKey = CampoInputName.endsWith(suffix) ? CampoInputName.slice(0, -suffix.length) : CampoInputName;

        this.setState(prevState => ({
            datosFormulario: {
                ...prevState.datosFormulario,
                [idFieldKey]: id,
                [nameFieldKey]: nombre
            },
            searchTerm: ''
        }), () => {
            // Llenar campo ID en DOM por seguridad/compatibilidad
            if (CampoInput) {
                const idField = document.getElementById(CampoInput);
                if (idField) {
                    idField.value = id;
                }
            }

            // Llenar campo nombre en DOM por seguridad/compatibilidad
            if (CampoInputName) {
                const nameField = document.getElementById(CampoInputName);
                if (nameField) {
                    nameField.value = nombre;
                }
            }

            this.cerrarModalSeleccion();
        });
    }

    /**
     * Cerrar modal de selección
     */
    cerrarModalSeleccion = () => {
        const modalId = `ModalSelectSub_${this.props.menu}`;
        const modalElement = document.getElementById(modalId);
        if (!modalElement) return;

        try {
            // Usar Bootstrap Modal
            if (window.bootstrap?.Modal) {
                const modal = window.bootstrap.Modal.getInstance(modalElement);
                if (modal) {
                    modal.hide();
                    console.log(`Modal de búsqueda ${modalId} cerrado con Bootstrap`);
                }
            } else {
                // Fallback para cerrar manualmente
                modalElement.classList.remove('show');
                modalElement.style.display = 'none';

                // Remover solo el backdrop más reciente (del modal de búsqueda)
                const backdrops = document.querySelectorAll('.modal-backdrop');
                if (backdrops.length > 0) {
                    backdrops[backdrops.length - 1].remove();
                }
                console.log(`Modal de búsqueda ${modalId} cerrado manualmente`);
            }
        } catch (error) {
            console.error('Error cerrando modal:', error);
        }
    }

    /**
     * Cambio en input de búsqueda
     */
    handleSearchChange = (e) => {
        this.setState({ searchTerm: e.target.value });
    }

    /**
     * Manejar cambio en inputs normales
     */
    handleInputChange = (e) => {
        const { name, value, type } = e.target;

        this.setState(prevState => ({
            datosFormulario: {
                ...prevState.datosFormulario,
                [name]: type === 'number' ? (value ? parseInt(value) : '') : value
            }
        }));
    }

    /**
     * Manejar cambio en archivos
     */
    handleFileChange = (e) => {
        // FormData manejará los archivos automáticamente
        console.log('Archivo seleccionado:', e.target.files?.[0]);
    }

    renderField(campo, key) {
        const esEditable = campo.campo_editable !== "No";
        const val = this.state.datosFormulario[campo.nombre_campo] !== undefined ? this.state.datosFormulario[campo.nombre_campo] : '';
        const valName = this.state.datosFormulario[campo.nombre_campo + '_name'] !== undefined ? this.state.datosFormulario[campo.nombre_campo + '_name'] : '';

        return (
            <div key={key} className={campo.tipo_dato === 'checkbox' ? 'col-md-6 d-flex align-items-center' : 'col-md-6'}>
                {/* Campo tipo blob (imagen/archivo) */}
                {campo.tipo_dato === 'blob' ? (
                    <>
                        <label htmlFor={`${campo.nombre_campo}_${this.props.menu}`} className="form-label fw-bold">
                            {campo.nombre_titulo}
                            {campo.obligatorio === 1 && <span className="text-danger">*</span>}
                        </label>
                        <div className="input-group">
                            <input
                                className="form-control"
                                type="file"
                                name={campo.nombre_campo}
                                id={`${campo.nombre_campo}_${this.props.menu}`}
                                onChange={this.handleFileChange}
                                disabled={!esEditable}
                                accept="image/*,.pdf"
                            />
                        </div>
                        <small className="text-muted d-block mt-1">
                            Formatos permitidos: PNG, JPG, PDF
                        </small>
                    </>
                ) : campo.trae_tabla === null ? (
                    campo.tipo_dato === 'checkbox' ? (
                        <div className="form-check mt-3">
                            <input
                                className="form-check-input"
                                type="checkbox"
                                name={campo.nombre_campo}
                                id={`${campo.nombre_campo}_${this.props.menu}`}
                                checked={val === "1" || val === 1 || val === true}
                                onChange={e => {
                                    this.setState(prevState => ({
                                        datosFormulario: {
                                            ...prevState.datosFormulario,
                                            [campo.nombre_campo]: e.target.checked ? "1" : "0"
                                        }
                                    }));
                                }}
                                disabled={!esEditable}
                            />
                            <label className="form-check-label fw-bold ms-1" htmlFor={`${campo.nombre_campo}_${this.props.menu}`}>
                                {campo.nombre_titulo}
                                {campo.obligatorio === 1 && <span className="text-danger">*</span>}
                            </label>
                        </div>
                    ) : (
                        // Campo de entrada normal
                        <>
                            <label htmlFor={`${campo.nombre_campo}_${this.props.menu}`} className="form-label fw-bold">
                                {campo.nombre_titulo}
                                {campo.obligatorio === 1 && <span className="text-danger">*</span>}
                            </label>
                            <input
                                className="form-control"
                                type={
                                    campo.tipo_dato === 'int' ? 'number' :
                                        campo.tipo_dato === 'date' ? 'date' :
                                            campo.tipo_dato === 'time' ? 'time' :
                                                'text'
                                }
                                name={campo.nombre_campo}
                                id={`${campo.nombre_campo}_${this.props.menu}`}
                                placeholder={`Ingrese ${campo.nombre_titulo.toLowerCase()}`}
                                value={val}
                                onChange={this.handleInputChange}
                                disabled={!esEditable}
                                required={campo.obligatorio === 1}
                            />
                        </>
                    )
                ) : (
                    // Campo con selección de relación
                    <>
                        <label htmlFor={`${campo.nombre_campo}_name_${this.props.menu}`} className="form-label fw-bold">
                            {campo.nombre_titulo}
                            {campo.obligatorio === 1 && <span className="text-danger">*</span>}
                        </label>
                        <input
                            className="form-control"
                            readOnly
                            type="hidden"
                            name={campo.nombre_campo}
                            id={`${campo.nombre_campo}_${this.props.menu}`}
                            value={val}
                        />
                        <div className="input-group">
                            <input
                                className="form-control"
                                readOnly
                                type="text"
                                name={`${campo.nombre_campo}_name`}
                                id={`${campo.nombre_campo}_name_${this.props.menu}`}
                                placeholder={`Seleccione ${campo.nombre_titulo.toLowerCase()}`}
                                value={valName}
                            />
                            <button
                                className="btn btn-outline-secondary"
                                type="button"
                                onClick={() => this.BuscarSub(
                                    campo.trae_tabla,
                                    campo.trae_value,
                                    campo.trae_campo,
                                    campo.nombre_campo,
                                    campo.trae_opcional
                                )}
                                title="Buscar registro"
                                disabled={!esEditable}
                            >
                                <FontAwesomeIcon icon={faSearch} />
                            </button>
                        </div>
                    </>
                )}
            </div>
        );
    }

    renderTabFields(pestana, camposPestana) {
        const result = [];
        let currentGroup = null;
        let currentGroupFields = [];

        const flushGroup = (key) => {
            if (currentGroupFields.length > 0) {
                const groupName = currentGroup;
                const fieldsToRender = [...currentGroupFields];
                result.push(
                    <div className="col-12" key={`group-wrapper-c-${groupName}-${key}`} style={{ marginBottom: "15px" }}>
                        <fieldset style={{
                            border: "2px solid #000000",
                            borderRadius: "8px",
                            padding: "20px 20px 10px 20px",
                            position: "relative",
                            marginTop: "15px"
                        }}>
                            <legend style={{
                                position: "absolute",
                                top: "-12px",
                                left: "20px",
                                background: "#ffffff",
                                padding: "0 10px",
                                fontSize: "14px",
                                fontWeight: "bold",
                                width: "auto",
                                float: "none",
                                color: "#333333"
                            }}>
                                {groupName}
                            </legend>
                            <div className="row g-3">
                                {fieldsToRender.map((row, idx) => this.renderField(row, `${key}-${idx}`))}
                            </div>
                        </fieldset>
                    </div>
                );
                currentGroupFields = [];
            }
        };

        camposPestana.forEach((campo, j) => {
            // No mostrar campo ID
            if (campo.nombre_campo === 'id') {
                if (this.props.idRegistro) {
                    result.push(
                        <input
                            key={j}
                            type="hidden"
                            name="id"
                            value={this.props.idRegistro}
                        />
                    );
                }
                return;
            }

            // Campo oculto para relación
            if (this.props.llave === campo.nombre_campo) {
                result.push(
                    <input
                        key={j}
                        type="hidden"
                        name={campo.nombre_campo}
                        id={`${campo.nombre_campo}_${this.props.menu}`}
                        value={this.props.relacionid || ''}
                    />
                );
                return;
            }

            const hasGroup = campo.grupo && campo.grupo.trim() !== "";
            if (hasGroup) {
                if (currentGroup && currentGroup !== campo.grupo) {
                    flushGroup(j);
                }
                currentGroup = campo.grupo;
                currentGroupFields.push(campo);
            } else {
                flushGroup(j);
                currentGroup = null;
                result.push(this.renderField(campo, j));
            }
        });

        flushGroup(camposPestana.length);
        return result;
    }

    render() {
        const {
            filteredItems,
            isLoadingOpenSub,
            searchTerm,
            guardando
        } = this.state;

        if (!this.props.tabla || this.props.tabla.length === 0) {
            return <div className="alert alert-danger">No hay campos para mostrar</div>;
        }

        // Filtrar items por búsqueda de manera optimizada
        const searchLower = searchTerm.toLowerCase().trim();
        const filtered = filteredItems.filter(item => {
            const nombreMatch = String(item.nombre || '').toLowerCase().includes(searchLower);
            const idMatch = String(item.id || '').toLowerCase().includes(searchLower);
            return nombreMatch || idMatch;
        });

        // Limitar los elementos visibles en el DOM para evitar lag
        const visibleItems = filtered.slice(0, 100);

        // Ordenar campos por el campo 'orden'
        const camposOrdenados = [...this.props.tabla].sort((a, b) => {
            const ordenA = parseInt(a.orden) || 0;
            const ordenB = parseInt(b.orden) || 0;
            return ordenA - ordenB;
        });

        // Agrupar campos por pestaña
        const pestanasMap = {};
        camposOrdenados.forEach(campo => {
            const nombrePestana = campo.pestana || 'Básico';
            if (!pestanasMap[nombrePestana]) {
                pestanasMap[nombrePestana] = [];
            }
            pestanasMap[nombrePestana].push(campo);
        });

        const pestanas = Object.keys(pestanasMap);

        return (
            <div className="formulario-crear">
                <form id={`form_registro_rel_${this.props.menu}`}>
                    <div className="card">
                        <div className="card-header bg-primary">
                            <h6 className="mb-0">Formulario de Registro</h6>
                        </div>

                        {/* Tabs */}
                        {pestanas.length > 1 && (
                            <ul className="nav nav-tabs border-bottom" id="formTabs" role="tablist">
                                {pestanas.map((pestana, i) => (
                                    <li key={i} className="nav-item">
                                        <a
                                            className={`nav-link ${i === 0 ? 'active' : ''}`}
                                            id={`tab-${pestana}`}
                                            data-bs-toggle="tab"
                                            href={`#content-${pestana}`}
                                            role="tab"
                                        >
                                            {pestana}
                                        </a>
                                    </li>
                                ))}
                            </ul>
                        )}

                        <div className="tab-content card-body" id="formTabContent">
                            {pestanas.map((pestana, i) => (
                                <div
                                    key={i}
                                    className={`tab-pane fade ${i === 0 ? 'show active' : ''}`}
                                    id={`content-${pestana}`}
                                    role="tabpanel"
                                >
                                    <div className="row g-3">
                                        {pestanasMap[pestana] && this.renderTabFields(pestana, pestanasMap[pestana])}
                                    </div>
                                </div>
                            ))}
                        </div>

                        {/* Footer con botones */}
                        <div className="card-footer bg-light d-flex justify-content-between align-items-center">
                            <small className="text-muted">
                                Los campos con <span className="text-danger">*</span> son obligatorios
                            </small>
                            <div className="gap-2 d-flex">
                                <button
                                    type="button"
                                    className="btn btn-secondary"
                                    data-bs-dismiss="modal"
                                    disabled={guardando}
                                >
                                    <FontAwesomeIcon icon={faTimes} className="me-2" />
                                    Cancelar
                                </button>
                                <button
                                    type="button"
                                    className="btn btn-primary"
                                    onClick={() => this.saverel()}
                                    disabled={guardando}
                                >
                                    {guardando ? (
                                        <>
                                            <FontAwesomeIcon icon={faSpinner} className="me-2 fa-spin" />
                                            Guardando...
                                        </>
                                    ) : (
                                        <>
                                            <FontAwesomeIcon icon={faSave} className="me-2" />
                                            Guardar Registro
                                        </>
                                    )}
                                </button>
                            </div>
                        </div>
                    </div>
                </form>

                {/* Modal para seleccionar registro de relación */}
                <div
                    className="modal fade"
                    id={`ModalSelectSub_${this.props.menu}`}
                    tabIndex="-1"
                    aria-labelledby={`ModalSelectSubLabel_${this.props.menu}`}
                    aria-hidden="true"
                    style={{ zIndex: 1085 }}
                >
                    <div className="modal-dialog modal-dialog-centered modal-dialog-scrollable" style={{ zIndex: 1090 }}>
                        <div className="modal-content">
                            <div className="modal-header bg-info text-white">
                                <h5 className="modal-title" id={`ModalSelectSubLabel_${this.props.menu}`}>
                                    Seleccione el registro
                                </h5>
                                <button
                                    type="button"
                                    className="btn-close btn-close-white"
                                    onClick={this.cerrarModalSeleccion}
                                    aria-label="Close"
                                />
                            </div>
                            <div className="modal-body">
                                <div>
                                    <input
                                        type="text"
                                        placeholder="Buscar por descripción..."
                                        className="form-control mb-3"
                                        value={searchTerm}
                                        onChange={this.handleSearchChange}
                                        autoFocus
                                    />
                                    {isLoadingOpenSub ? (
                                         <div className="text-center py-5">
                                             <div className="spinner-border text-primary" role="status">
                                                 <span className="visually-hidden">Cargando...</span>
                                             </div>
                                             <p className="mt-3 text-muted">Cargando datos...</p>
                                         </div>
                                     ) : filtered.length === 0 ? (
                                         <div className="text-center py-5">
                                             <FontAwesomeIcon icon={faSearch} size="3x" className="text-muted mb-3" />
                                             <p className="text-muted">
                                                 {searchTerm ? 'No se encontraron resultados' : 'No hay registros disponibles'}
                                             </p>
                                         </div>
                                     ) : (
                                         <div className="table-responsive">
                                             {filtered.length > 100 && (
                                                 <div className="alert alert-info py-2 mb-2" style={{ fontSize: '0.85rem' }}>
                                                     Mostrando los primeros 100 de {filtered.length} resultados. Por favor, refine su búsqueda.
                                                 </div>
                                             )}
                                             <table className="table table-hover table-sm align-middle">
                                                 <thead className="table-light">
                                                     <tr>
                                                         <th className="px-2">ID</th>
                                                         <th>DESCRIPCIÓN</th>
                                                     </tr>
                                                 </thead>
                                                 <tbody>
                                                     {visibleItems.map((item) => (
                                                         <tr
                                                             key={item.id}
                                                             style={{ cursor: 'pointer' }}
                                                             className="align-middle"
                                                         >
                                                             <td className="px-2">
                                                                 <span className="badge bg-secondary">{item.id}</span>
                                                             </td>
                                                             <td>
                                                                 <button
                                                                     type="button"
                                                                     className="btn btn-link p-0 text-decoration-none text-start w-100 text-dark"
                                                                     onClick={() => this.Seleccionar(item.id, item.nombre)}
                                                                 >
                                                                     {item.nombre}
                                                                 </button>
                                                             </td>
                                                         </tr>
                                                     ))}
                                                 </tbody>
                                             </table>
                                         </div>
                                     )}
                                </div>
                            </div>
                            <div className="modal-footer">
                                <button
                                    type="button"
                                    className="btn btn-secondary"
                                    onClick={this.cerrarModalSeleccion}
                                >
                                    Cerrar
                                </button>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        );
    }
}

export default CrearFormulario;